import { AVATAR_COLORS } from "data/avatar-colors";

export const getAvatarColorByUuid = (
    uuid: string
): { from: string; to: string } => {
    const id: number = Number("0x" + uuid.split("-")[0]);
    return AVATAR_COLORS[id % AVATAR_COLORS.length];
};
